<template>
  <div>
    <b-button block @click="handleToggleClick"> </b-button>
    <b-collapse :id="assessmentInputId" class="mt-2">
      <div
        style="
          background-color: #ffffff;
           border-color: black;
           border-radius: 25px;
           margin-left: 15px;
           margin-right: 15px;
           padding: 45px;
          "
      >
        <b-row>
          <b-col>
            <h3>
              <strong>{{ assessmentIdx + 1 }}.</strong>
              {{ assessmentQuestion }}
            </h3>
          </b-col>
        </b-row>
        <b-row style="margin-top: 25px">
          <b-col sm="2">
            <b-img
              v-if="form && form.imgURL"
              v-bind="mainProps"
              :src="form.imgURL"
              rounded
              style="object-fit: scale-down"
              :alt="` Image`"
            />
            <image-upload
              v-else
              ref="image-upload"
              text-drag="Upload or Drag Care Plan Cover Photo (.png, .jpg)"
              :img-upload-idx="idxImg"
              img-upload-type="careplans"
              :storage-path="storagePath"
              :max-image="1"
              :show-edit="false"
              :show-delete="false"
              style="height:90%;width:90%"
              @img-uploaded-url="handleImgUploadedURL"
            />
          </b-col>
          <b-col sm="8">
            <template>
              <b-form-textarea
                id="textarea"
                v-model="form.text"
                size="lg"
                rows="4"
                :placeholder="assessmentPlaceholder"
              />
              <b-row>
                <b-col v-if="true">
                  <b-icon
                    icon="mic"
                    variant="dark"
                    scale="2"
                    class="float-right"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  v-if="assessmentExamples && assessmentExamples.length > 0"
                >
                  Examples: {{ assessmentExamples }}
                </b-col>
              </b-row>
            </template>
          </b-col>
          <b-col sm="2">
            <b-row style="margin-top: 15px;">
              <b-col>
                <b-button
                  style="margin-right: 25px;"
                  title="Page Left"
                  variant="primary"
                  :disabled="assessmentIdx <= 0"
                  @click="handlePageTo(assessmentIdx - 1)"
                >
                  <b-icon icon="chevron-bar-left" aria-hidden="true" />
                </b-button>
              </b-col>
              <b-col> </b-col>
              <b-col>
                <b-button
                  variant="primary"
                  :disabled="assessmentIdx == maxAssessments - 1"
                  @click="handlePageTo(assessmentIdx + 1)"
                >
                  <b-icon icon="chevron-bar-right" aria-hidden="true" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            May we have a care plan specialist review your plan?
          </b-col>
          <b-col>
            <b-button
              pill
              variant="primary"
              :disabled="!canAddAssessment"
              @click="handleAddAnswer"
            >
              Save
            </b-button>
            <b-button
              pill
              style="background-color:blue; color:white"
              :disabled="!canAddAssessment"
              @click="handleAddAnswer"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";

export default {
  name: "Assessment_Input",
  mixins: [UploadImage],
  components: {
    ImageUpload
  },
  props: {
    assessmentIdx: {
      type: Number,
      default: null
    },
    assessment: {
      type: Object,
      default: () => {
        return {};
      }
    },
    newAssessmentCount: {
      type: Number,
      default: null
    },
    maxAssessments: {
      type: Number,
      default: 0
    }
  },
  created() {},
  mounted() {
    this.handleToggleClick();
    this.handleSetForm(this.answerCurrent);
  },
  computed: {
    ...mapGetters({}),
    canAddAssessment() {
      return (
        this.form &&
        this.form.text &&
        this.form.text.length > 10 &&
        (this.answerCurrent && this.answerCurrent.text
          ? this.form.text != this.answerCurrent.text
          : true)
      );
    },
    answers() {
      return this.assessment &&
        this.assessment.answers &&
        Array.isArray(this.assessment.answers)
        ? this.assessment.answers
        : [];
    },
    answersSorted() {
      let _answers = this.answers;
      return _answers && Array.isArray(_answers)
        ? _answers.sort((a, b) => {
            if (
              a._created_at &&
              b._created_at &&
              a._created_at.seconds &&
              b._created_at.seconds
            ) {
              this.momentTest = a._created_at.seconds;
              return b._created_at.seconds - a._created_at.seconds;
            }
            return false;
          })
        : [];
    },
    answerCurrent() {
      return this.answersSorted &&
        Array.isArray(this.answersSorted) &&
        this.answersSorted.length > this.idxAnswer
        ? this.answersSorted[this.idxAnswer]
        : null;
    },
    canGenerate() {
      return this.newAssessmentCount == 0;
    },
    assessmentQuestion() {
      return this.assessment && this.assessment.question
        ? this.assessment.question
        : "Invalid Question";
    },
    assessmentExamples() {
      return this.assessment && this.assessment.examples
        ? this.assessment.examples
        : null;
    },
    assessmentPlaceholder() {
      return this.assessment && this.assessment.placeholder
        ? this.assessment.placeholder
        : "Please provide as much info as possible";
    },
    assessmentId() {
      return this.assessment && this.assessment.id
        ? this.assessment.id
        : "InvalidId";
    }
  },
  watch: {
    answerCurrent(newValue, oldValue) {
      //temp- may take out
      this.handleSetForm(newValue);
    }
  },
  methods: {
    handleToggleClick() {
      this.$root.$emit("bv::toggle::collapse", this.assessmentInputId);
    },
    handlePageTo(pageNumber) {
      this.$emit("page-to", pageNumber);
    },
    handleImgUploadedURL(idxImg, url) {},
    handleAddAnswer() {
      this.$emit("input-form", this.assessmentId, this.form);
    },
    handleSetForm(formInput) {
      this.form = formInput ? _.clone(formInput) : _.clone(this.formDefault);
    },
    handleGeneratePlan() {
      this.$emit("generate-plan");
    }
  },
  data() {
    return {
      idxImg: 0,
      idxAnswer: 0,
      form: {},
      assessmentInputId: "assessment-input-collapse",
      formDefault: {
        text: "",
        imgURLs: [],
        imgURL: null,
        audioURLs: []
      },
      storagePath: "careplan_assessment_imgs",
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 200,
        height: 200,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
